export const NFL_HEADER_COPY = {
  eyebrow: "Sports Hub • NFL",
  title: "NFL Dashboard",
  description: "Track live games, standings, and teams from the National Football League",
};
